import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { clearStoredPaymentCommands } from '../payment-command-store.service';

@Injectable()
export class HttpErrorsInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const isLimitedPublicSessionRequest = [
          '/public/vehicle-evidence/',
          '/public/vehicle-passports/',
        ].some((path) => request.url.includes(path));
        if (error.status === 401 && !isLimitedPublicSessionRequest) {
          clearStoredPaymentCommands();
          localStorage.clear();
          void this.router.navigate(['login']);
        }
        return throwError(() => error);
      }),
    );
  }
}
